<script setup>
  import { ref, computed, watchEffect} from 'vue';

  const props = defineProps({
    position: {
      type: Object,
      required: true
    },
    graph: {
      type: [Object, null],
      required: true
    }
  });

  const markerPosition = ref({ x: 0, y: 0 });
  const graph = ref(props.graph)


  const labelStyle = computed(() => {
    return {
      position: 'absolute',
      left: `${markerPosition.value.x + props.graph.plotLeft}px`,
      top: `${markerPosition.value.y}px`,
    };
  });

  watchEffect(() => {
    if (props.position) {
      markerPosition.value = props.position;
    }
  });
</script>

<template>
  <Teleport :disabled="!graph.container" :to="graph.container">
    <div
      class="jwx-tide-graph__now-marker"
      :style="labelStyle"
    ></div>
  </Teleport>
</template>